import * as React from 'react';

interface CustomContactButtonsProps {
  isMlsCustomContact?: boolean;
  customContactSaved: boolean;
  deleteCustomAgentOrContact: any;
  selectSearchRoster: any;
  bookFor: any;
  nextStepLabel?: any;
  customContactEdit: any;
  isSubmitting?: any;
  updateState: any;
  appointment: any;
  hideCustomAgentEdit?: any;
}
const CustomContactButtons: React.FC<CustomContactButtonsProps> = ({
  isMlsCustomContact,
  customContactSaved,
  deleteCustomAgentOrContact,
  selectSearchRoster,
  bookFor,
  nextStepLabel,
  customContactEdit,
  isSubmitting,
  updateState,
  appointment,
  hideCustomAgentEdit,
}) => {
  const [showNote, setShowNote] = React.useState(false);

  const changeHandler = (e: any) => {
    const { value } = e.target;
    updateState((draft: any) => {
      draft.appointment.note = value;
    });
  };

  return (
    <div className="row col-md-12">
      {customContactSaved && (
        <div className="pull-left">
          {showNote ? (
            <div className="form-group">
              <label>Notes</label>
              <textarea
                value={appointment.note}
                data-cy="input-note"
                onChange={changeHandler}
                name="note"
                className="form-control"
                rows={6}
              />
            </div>
          ) : (
            <button
              onClick={() => setShowNote(true)}
              className="btn btn-default"
              data-cy="add-note"
            >
              Add Note
            </button>
          )}
        </div>
      )}

      <div className="pull-right">
        {(!customContactSaved ||
          (bookFor !== 'nonAgent' && bookFor !== 'others')) && (
          <a
            className="pull-right btn btn-default margin-right custom-contact-buttons"
            onClick={selectSearchRoster}
          >
            Cancel
          </a>
        )}
        {!customContactSaved && (
          <button
            type="submit"
            className="pull-right btn btn-primary margin-right custom-contact-buttons"
            data-cy="custom-next-step"
            disabled={isSubmitting}
          >
            {nextStepLabel}
          </button>
        )}

        {customContactSaved && !isMlsCustomContact && !hideCustomAgentEdit && (
          <button
            className="btn btn-danger pull-right margin-right custom-contact-buttons"
            onClick={deleteCustomAgentOrContact}
            data-cy="delete-profile"
          >
            <i className="fa fa-trash" aria-hidden="true"></i>Delete Profile
          </button>
        )}
        {customContactSaved && !isMlsCustomContact && !hideCustomAgentEdit && (
          <button
            className="pull-right btn btn-primary margin-right custom-contact-buttons"
            onClick={customContactEdit}
            data-cy="edit-profile"
          >
            Edit Profile
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomContactButtons;
